import React from 'react';
import { NavLink } from 'react-router-dom';
import './Footer.css';
const Footer = () => {
  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12 mx-auto mb-3">
              <h5>About Us</h5>
              <p className="p_mar">
                Here you can use rows and columns to organize your footer
                content. Lorem ipsum dolor sit amet, consectetur adipisicing
                elit.
              </p>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 mx-auto mb-3">
              <h5>Useful Link</h5>
              <ul>
                <li>
                  <NavLink to="/home">
                    <i className="fa fa-user mr-2"></i> Account Details
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/account/setting">
                    <i className="fa fa-cog mr-2"></i> Account Setting
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/privacy_policy">
                    <i className="fa fa-print mr-2"></i> Privacy Policy
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/self_service">
                    <i className="fa fa-server mr-2"></i> Self Service
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 mx-auto mb-3">
              <h5>Contact Us</h5>
              <ul>
                <li>
                  <NavLink to="/">
                    <i className="fa fa-home mr-2"></i> Narsapuram, India
                  </NavLink>
                </li>
                <li>
                  <a href="mailto:kriova@outlook.com">
                    <i className="fa fa-envelope mr-2"></i> kriova@outlook.com
                  </a>
                </li>
                <li>
                  <a href="tel:+919169991555">
                    <i className="fa fa-phone mr-2"></i> +919169991555
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6 col-sm-12 mx-auto mb-3">
              <div className="social_icon_box">
                <div className="social_icon">
                  <a href="">
                    <i className="fa fa-facebook"></i>
                  </a>
                </div>
                <div className="social_icon">
                  <a href="">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </div>
                <div className="social_icon">
                  <a href="">
                    <i className="fa fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 mx-auto mb-3">
              <div className="fright">© 2022 Copyright: hecord.com</div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
